import { render, staticRenderFns } from "./DashboardTopMenu.vue?vue&type=template&id=04bcbe4a&"
import script from "./DashboardTopMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardTopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports